import apiClient from './client';

// Get daily statistics (admin only)
export const getDailyStats = async (days = 7) => {
  try {
    const response = await apiClient.get(`/stats/daily?days=${days}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get statistics summary (admin only)
export const getStatsSummary = async () => {
  try {
    const response = await apiClient.get('/stats/summary');
    return response.data;
  } catch (error) {
    throw error;
  }
};